import Loading from 'components/Loading'
import { BigNumber } from 'ethers'
import { formatEther } from 'ethers/lib/utils'
import { memo, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import {
  useAmount,
  useSelectedToken,
  useSelectFast,
  useWithdrawLayoutType,
} from 'store/withdraw/hook'
import { WithdrawLayoutType } from 'store/withdraw/types'
import { Space8, Wing10 } from 'styles'
import { parseWeiToEther, toFixed } from 'utils/number'
import { FeeWrap, ReceiveWrap } from '../Deposit/DepositSelectAssets'

import { StyledControlInputLarge } from '../../styles/Control'

const WithdrawReceive = memo<{
  receiveAmount: BigNumber | undefined
  fastFee: BigNumber | null
  withdrawalFee: BigNumber | undefined
  pending: boolean
  chainId?: number
}>(({ receiveAmount, fastFee, withdrawalFee, pending, chainId }) => {
  const amount = useAmount()
  const selectedToken = useSelectedToken()
  const { t } = useTranslation()
  const layoutType = useWithdrawLayoutType()
  const selectFast = useSelectFast()

  const tokenDecimals = useMemo(() => {
    if (selectedToken && chainId) {
      return selectedToken.chains[chainId].decimals
    }
    return 0
  }, [selectedToken, chainId])

  return (
    <>
      <StyledControlInputLarge sx={{ borderRadius: '4px' }}>
        <ReceiveWrap>
          <span className="left">
            {t('deposit-receive', { defaultValue: 'You will receive' })}
          </span>
          <span className="right">
            {layoutType === WithdrawLayoutType.Withdraw
              ? toFixed(parseWeiToEther(receiveAmount!), tokenDecimals)
              : parseWeiToEther(receiveAmount!)}{' '}
            {selectedToken?.name}
          </span>
        </ReceiveWrap>
      </StyledControlInputLarge>
      <Space8 />
      <FeeWrap>
        <span>Withdrawal Fee:</span>
        {pending ? (
          <Loading size={12} />
        ) : (
          <span>{amount ? formatEther(withdrawalFee ?? '0') : '0'}</span>
        )}
        <span>{selectedToken?.name}</span>
        {layoutType === WithdrawLayoutType.Withdraw && selectFast ? (
          <>
            <Wing10>+</Wing10>
            Fast Fee: {fastFee ? formatEther(fastFee) : '0'}{' '}
            {selectedToken?.name}
          </>
        ) : null}
      </FeeWrap>
    </>
  )
})
export default WithdrawReceive
